import { MenuSidebar } from 'src/app/core/constants/navigation.config';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';

import { SoctripIcons } from 'src/app/core/constants/soctrip-icon.enum';
import { NavigationItem } from 'src/app/core/models/interfaces/navigation';
import { GetApiService } from 'src/app/core/services/get-api.service';
import { ChatService } from 'src/app/core/services/chat.service';
import { environment } from 'src/environments/environment';
import { NgxPermissionsService } from 'ngx-permissions';
import { PermissionCode } from 'src/app/core/constants/permission-code';
import { AppRoutes } from 'src/app/core/enum/routes.enum';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
})
export class SidebarComponent implements OnInit {
  dialItems: any[];
  MenuSidebar = MenuSidebar;
  isMenuShow: boolean = true;
  showChildren: boolean[] = [];
  chatPendingCount = 0;

  @Input() sidebarVisible = false;
  @Output() sidebarVisibleChange = new EventEmitter<boolean>();
  protected readonly SoctripIcons = SoctripIcons;

  constructor(
    private router: Router,
    private getApiService: GetApiService,
    private chatService: ChatService,
    private permissionsService: NgxPermissionsService,
  ) {}

  ngOnInit() {
    this.setupSideBar();
    this.showChildren = this.MenuSidebar.map((item) => !!item.children);
    this.getChatPendingCount();
    this.chatService.pendingSessionChanges.subscribe((value) => {
      if (value) {
        this.getChatPendingCount();
      }
    });
    this.permissionsService.permissions$.subscribe((permissions) => {
      this.setupSideBar();
    });
  }

  setupSideBar() {
    const toggleItem = {
      icon: 'sctr-icon-chevron-right',
      command: () => {
        this.isMenuShow = !this.isMenuShow;
      },
    };

    this.MenuSidebar.forEach((item) => {
      this.permissionsService
        .hasPermission([PermissionCode.SUPER_ADMIN, ...item.permission])
        .then((hasEditPermission) => {
          item.visible = hasEditPermission && item.visible;
        });
      if (item.children) {
        item.children.forEach((subItem) => {
          this.permissionsService
            .hasPermission([PermissionCode.SUPER_ADMIN, ...subItem.permission])
            .then((hasEditPermission) => {
              subItem.visible = hasEditPermission && subItem.visible;
            });
        });
      }
    });

    this.dialItems = _.cloneDeep(MenuSidebar);
    this.dialItems.unshift(toggleItem);
    this.dialItems.forEach((item) => {
      item.routerLink = [item.path];
      item.icon += ' before:!text-white';
    });
  }

  isActive(path: string, isParent?: boolean) {
    const locationPath = window.location.pathname;
    if (isParent) {
      return locationPath.slice(1) === path;
    } else {
      const index = locationPath.search(path);
      return (
        index > 0 &&
        locationPath[index - 1] === '/' &&
        locationPath.includes(path)
      );
    }
  }

  getMenuIcon() {
    return this.isMenuShow ? 'pi pi-chevron-left' : 'pi pi-chevron-right';
  }

  updateSideBar(value: boolean = this.sidebarVisible) {
    this.sidebarVisible = value;
    this.sidebarVisibleChange.emit(this.sidebarVisible);
  }

  onNavigate(path?: string) {
    if (!path) return;
    this.router.navigateByUrl(path);
    this.updateSideBar(false);
  }

  onClickItemSidebar(item: NavigationItem, index: number) {
    if (item.children) {
      this.showChildren[index] = !this.showChildren[index];
    } else {
      this.onNavigate(item.path);
    }
  }

  getChatPendingCount() {
    this.getApiService
      .getAdminChatSessionsCount('PENDING', environment.CHAT_MODULE)
      .subscribe({
        next: (res: any) => {
          this.chatPendingCount = res?.data;
        },
        error: (err) => {
          console.error(err);
        },
      });
  }
}
